/*
 * Module helpers for module merrill-helper.
 * @file
 */

/**
 * Insert all of you handlebars helper functions for this module within this object.
 * @type {object<function>}
 */

/**
 * The merrill-helper-module Sparta Module.
 * @param {times} times times
 * @param {block} block block
 * @returns {string} output output
 */
function nTimes(times, block) {
  let output = '';
  for (let i = 0; i < times; ++i) {
    output += block.fn(i);
  }
  return output;
}

export { nTimes };
